export default function ConfirmOnExitDirective(gettextCatalog) {
	'ngInject';

	return function($scope, elem, attrs) {
		if (elem[0].nodeName === 'FORM') {
			window.onbeforeunload = function() {
				if (
					angular.element(elem[0]).hasClass('ng-dirty') &&
					!angular.element(elem[0]).hasClass('ng-submitted')
				) {
					return gettextCatalog.getString(
						'You have unsaved changes. Are you sure you want to leave the page?'
					);
				}
			};
			$scope.$on('$stateChangeStart', function(event, next, current) {
				if (!event.defaultPrevented) {
					if (
						angular.element(elem[0]).hasClass('ng-dirty') &&
						!angular.element(elem[0]).hasClass('ng-submitted')
					) {
						if (
							!confirm(
								gettextCatalog.getString(
									'You have unsaved changes. Are you sure you want to leave the page?'
								)
							)
						) {
							event.preventDefault();
						}
					}
				}
			});
		}
	};
}
